function convertRomanNumerals(container) {
  const productTitles = container.querySelectorAll('.right .name a'); // select product titles within the container
  const romanNumeralRegex = /(?<=\s)(i{1,3}|iv|v|vi{1,3}|ix|x{1,3}|xl|l|lx{1,3}|xc|c)(?=\s|$)/gi; // regular expression to match Roman numerals with spaces before them

  productTitles.forEach(title => {
    const titleText = title.textContent; // get the text content of the title
    const formattedTitle = titleText.replace(romanNumeralRegex, '<span class="roman-numeral">$&</span>'); // wrap each matched Roman numeral in a span element
    title.innerHTML = formattedTitle; // replace the original title with the formatted title HTML
  });
}

// Call the function when the page loads
document.addEventListener('DOMContentLoaded', function () {
  convertRomanNumerals(document.body); // Apply to the entire page initially
});

// Attach a MutationObserver to detect changes in the document
const observer = new MutationObserver((mutationsList, observer) => {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      const addedNodes = mutation.addedNodes;
      for (const node of addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (node.classList.contains('product-item-col')) {
            convertRomanNumerals(node); // Apply to the new products container
          }
        }
      }
    }
  }
});

observer.observe(document.body, { childList: true, subtree: true });
